import Vue from 'vue';
import Router from 'vue-router';
// import Layout from '@/layout/index.vue';
// import { menuRouter } from '@/config/menus';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/classroom/',
  routes: [
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound/NotFound.vue'),
      meta: {
        title: '出错了',
        keepAlive: true
      },
    },
    // {
    //   path: '/',
    //   name: 'main',
    //   component: Layout,
    //   redirect: '/index',
    //   children: menuRouter
    // },
    {
      path: '/recommend',
      name: 'recommend',
      component: () => import(/* webpackChunkName: "recommend" */ './views/Recommend/Recommend.vue'),
      meta: {
        title: '推荐',
        keepAlive: true
      },
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import(/* webpackChunkName: "agreement" */ './views/Agreement/Agreement.vue'),
      meta: {
        title: '有讲课堂用户协议',
        keepAlive: true
      },
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        keepAlive: true
      },
    },
    {
      path: '/article',
      name: 'article',
      component: () => import(/* webpackChunkName: "article" */ './views/ArticleMain.vue'),
      meta: {
        keepAlive: true
      },
    },
    {
      path: '/category',
      name: 'category',
      component: () => import(/* webpackChunkName: "category" */ './views/Category/Category.vue'),
      meta: {
        title: '分类',
      },
    },
    {
      path: '/user',
      name: 'user',
      component: () => import(/* webpackChunkName: "user" */ './views/User/User.vue'),
      meta: {
        title: '个人主页',
        keepAlive: true
      },
    },
    {
      path: '/content',
      name: 'content',
      component: () => import(/* webpackChunkName: "content" */ './views/ContentDetail/ContentDetail.vue'),
      meta: {
        title: '详情',
        keepAlive: true
      },
    },
    {
      path: '/content/:id',
      name: 'content-id',
      component: () => import(/* webpackChunkName: "content" */ './views/ContentDetail/ContentDetail.vue'),
      meta: {
        title: '详情',
        keepAlive: true
      },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: {
        title: '关于我们',
        keepAlive: true
      },
    },
    {
      path: '/topic',
      name: 'topic',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "topic" */ './views/Topic/Topic.vue'),
      meta: {
        title: '专题',
        keepAlive: true
      },
    },
    {
      path: '/discuss',
      name: 'discuss',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "discuss" */ './views/Discuss/Discuss.vue'),
      meta: {
        title: '话题',
        keepAlive: true
      },
    },
    {
      path: '/download',
      name: 'download',
      component: () => import(/* webpackChunkName: "download" */ './views/Download/Download.vue'),
      meta: {
        title: '下载有讲课堂',
        keepAlive: true
      },
    },
    {
      path: '/fans',
      name: 'fans',
      component: () => import(/* webpackChunkName: "fans" */ './views/Fans/Fans.vue'),
      meta: {
        title: 'Ta的粉丝',
        keepAlive: true
      },
    },
    {
      path: '/follow',
      name: 'follow',
      component: () => import(/* webpackChunkName: "attention" */ './views/Attention/Attention.vue'),
      meta: {
        title: 'Ta的关注',
      },
    },
    {
      path: '/explain',
      name: 'explain',
      component: () => import(/* webpackChunkName: "explain" */ './views/Explain/Explain.vue'),
      meta: {
        title: '规则说明',
        keepAlive: true
      },
    },
    {
      path: '/distribut-instructions',
      name: 'distribut-instructions',
      component: () => import(/* webpackChunkName: "distribut-instructions" */ './views/DistributInstructions/DistributInstructions.vue'),
      meta: {
        title: '推广须知',
        keepAlive: true
      },
    },
    {
      path: '/',
      redirect: '/recommend',
    },
    { path: '*', redirect: '/404' },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login/Login.vue'),
      meta: {
        title: '登录',
        keepAlive: true
      },
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import(/* webpackChunkName: "invite" */ './views/InviteNew/InviteNew.vue'),
      meta: {
        title: '送你有讲课堂优惠券',
        keepAlive: true
      },
    },
    {
      path: '/lottery',
      name: 'lottery',
      component: () => import(/* webpackChunkName: "lottery" */ './views/Lottery/Lottery.vue'),
      meta: {
        title: '幸运抽奖',
        keepAlive: false // false为不缓存
      },
    },
    {
      path: '/explain-for-coin',
      name: 'explain-for-coin',
      component: () => import(/* webpackChunkName: "explain-for-coin" */ './views/ExplainForCoin/ExplainForCoin.vue'),
      meta: {
        title: '规则说明',
        keepAlive: true
      },
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "privacy-policy" */ './views/PrivacyPolicy/PrivacyPolicy.vue'),
      meta: {
        title: '有讲课堂隐私政策',
        keepAlive: true
      },
    },
    {
      path: '/privacy-policy-new',
      name: 'privacy-policy-new',
      component: () => import(/* webpackChunkName: "privacy-policy-new" */ './views/PrivacyPolicyNew/PrivacyPolicyNew.vue'),
      meta: {
        title: '有讲课堂隐私政策',
        keepAlive: true
      }
    },
    {
      path: '/camp/:series_id',
      // '/camp/1162' 没有分销
      // '/camp/1162-134242' 带了分销id
      name: 'camp-id',
      component: () => import(/* webpackChunkName: "camp" */ './views/CampDetails/CampDetails.vue'),
      meta: {
        title: '训练营详情页',
      },
    },
    {
      path: '/camp-learning/:series_id',
      name: 'camp-learning',
      component: () => import(/* webpackChunkName: "camp-learning" */ './views/CampLearning/CampLearning.vue'),
      meta: {
        title: '训练营学习页',
      },
    },
    {
      path: '/camp-learning-report/:series_id',
      name: 'camp-learning-report',
      component: () => import(/* webpackChunkName: "camp-learning" */ './views/CampLearning/CampLearningReport.vue'),
      meta: {
        title: '训练营学习报告',
      },
    },
    {
      path: '/camp-play/:lesson_id',
      name: 'camp-play',
      component: () => import('./views/CampPlay/Index.vue'),
      meta: {
        title: '训练营播放页',
      },
    },
    {
      path: '/camp-try-see/:lesson_id',
      name: 'camp-try-see',
      component: () => import('./views/CampTrySee/Index.vue'),
      meta: {
        title: '试看',
      },
    },
    {
      path: '/camp-order/:series_id',
      name: 'camp-order-id',
      component: () => import(/* webpackChunkName: "camp-play" */ './views/CampOrder/CampOrder.vue'),
      meta: {
        title: '确认订单',
      },
    },
    {
      path: '/unionpay-installment-finished',
      name: 'unionpay-installment-finished',
      component: () => import(/* webpackChunkName: "camp-play" */ './views/CampOrder/unionpayInstallmentFinished.vue'),
      meta: {
        title: '银联分期支付完成',
      },
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: () => import(/* webpackChunkName: "protocol" */ './views/CampOrder/Protocol.vue'),
      meta: {
        title: '训练营服务协议',
      },
    },
    {
      path: '/protocolMetaPixel',
      name: 'protocolMetaPixel',
      component: () => import(/* webpackChunkName: "protocol" */ './views/CampOrder/ProtocolMetaPixel.vue'),
      meta: {
        title: '训练营服务协议',
      },
    },
    {
      path: '/protocolBbk',
      name: 'protocolBbk',
      component: () => import(/* webpackChunkName: "protocol" */ './views/CampOrder/ProtocolBbk.vue'),
      meta: {
        title: '训练营服务协议',
      },
    },
    {
      path: '/clock-in-theme',
      name: 'clock-in-theme',
      component: () => import(/* webpackChunkName: "clock-in-theme" */ './views/ClockInTheme/index.vue'),
      meta: {
        title: '打卡主题页',
        keepAlive: true
      }
    },
    {
      path: '/clock-in/:id/:date/:edit',
      name: 'clock-in',
      component: () => import(/* webpackChunkName: "clock-in" */ './views/ClockIn/index.vue'),
      meta: {
        title: '打卡'
      },
      props: true
    },
    {
      path: '/my-clock-in',
      name: 'my-clock-in',
      component: () => import(/* webpackChunkName: "my-clock-in" */ './views/MyClockIn/index.vue'),
      meta: {
        title: '我的打卡'
      }
    },
    {
      path: '/clock-in-detail/:id',
      name: 'clock-in-detail',
      component: () => import(/* webpackChunkName: "clock-in-detail" */ './views/ClockInDetail/index.vue'),
      meta: {
        title: '打卡详情'
      },
      props: true
    },
    {
      path: '/clock-in-detail-long',
      name: 'clock-in-detail-long',
      component: () => import(/* webpackChunkName: "clock-in-detail-long" */ './views/ClockInDetail/longPicture.vue'),
      meta: {
        title: '生成长图'
      }
    },
    {
      path: '/admin-class-list',
      name: 'admin-class-list',
      component: () => import(/* webpackChunkName: "admin-class-list" */ './views/AdminClassList/index.vue'),
      meta: {
        title: '班级列表'
      }
    },
    {
      path: '/admin-class-detail/:id',
      name: 'admin-class-detail',
      component: () => import(/* webpackChunkName: "admin-class-detail" */ './views/AdminClassDetails/index.vue'),
      props: true
    },
    {
      path: '/admin-comment',
      name: 'admin-comment',
      component: () => import(/* webpackChunkName: "admin-comment" */ './views/AdminComment/index.vue'),
      meta: {
        title: '点评'
      }
    },
    {
      path: '/training-camp',
      name: 'training-camp',
      component: () => import(/* webpachChunkName: "training-camp" */ './views/TrainingCamp/index.vue'),
      meta: {
        title: '训练营',
        keepAlive: true
      }
    },
    {
      path: '/quality-course',
      name: 'quality-course',
      component: () => import(/* webpachChunkName: "quality-course" */ './views/QualityCourse/index.vue'),
      meta: {
        title: '精品课',
        keepAlive: true
      }
    },
    {
      path: '/apply/refund',
      name: 'apply-refund',
      query: { purchase_ids: "" },
      component: () => import(/* webpachChunkName: "apply" */ './views/RefundPostponeApply/refund.vue'),
      meta: {
        title: '申请退款',
        keepAlive: true
      }
    },
    {
      path: '/apply/postpone',
      name: 'apply-postpone',
      query: {series_ids: ""},
      component: () => import(/* webpachChunkName: "apply" */ './views/RefundPostponeApply/postpone.vue'),
      meta: {
        title: '申请延期',
        keepAlive: true
      }
    },
    {
      path: '/apply/change-account/query',
      name: 'apply-change-account',
      query: {series_ids: ""},
      component: () => import(/* webpachChunkName: "apply" */ './views/RefundPostponeApply/query_change_series'),
      meta: {
        title: '申请换号',
        keepAlive: true
      }
    },

    {
      path: '/apply/change-account/:user_id/',
      name: 'apply-change-account',
      query: {series_ids: ""},
      component: () => import(/* webpachChunkName: "apply" */ './views/RefundPostponeApply/change_account'),
      meta: {
        title: '申请换号',
        keepAlive: true
      }
    },

  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});
